<div class="p-2 text-xl" *ngIf="internalTourData$ | async as data">
  <div class="font-bold text-3xl my-2 p-1">5F Tour Internal Dashboard</div>
  <div class="flex divide-x-2 divide-gray-400 card-with-shadow bg-white rounded px-3 py-5">
    <div class="flex w-full font-semibold pr-3 justify-between items-center">
      <div>Created Tours</div>
      <div class="text-5xl">{{ data.totalCreatedTourCount | number }}</div>
    </div>
    <div class="flex w-full font-semibold pl-3 justify-between items-center">
      <div>In Progress Tours</div>
      <div class="text-5xl">{{ data.inProgressTourCount | number }}</div>
    </div>
  </div>
  <div class="flex gap-x-3 mt-5">
    <div class="w-full">
      <div class="font-bold pl-1">Dispatcher Stats</div>
      <div class="card-with-shadow bg-white rounded p-3 mt-2 border-t-4 border-gray-600 divide-y-2 divide-gray-300">
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Dispatching Companies</div>
          <div class="text-3xl">{{ data.dispatchCompanyCount | number }}</div>
        </div>
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Dispatching Companies with Drivers</div>
          <div class="text-3xl">{{ data.dispatchCompanyWithDriversCount | number }}</div>
        </div>
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Dispatching Companies with Tours</div>
          <div class="text-3xl">{{ data.dispatchCompanyWithTourDriversCount | number }}</div>
        </div>
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Dispatchers</div>
          <div class="text-3xl">{{ data.dispatcherUserCount | number }}</div>
        </div>
      </div>
    </div>
    <div class="w-full">
      <div class="font-bold pl-1">Carrier & Driver Stats</div>
      <div class="card-with-shadow bg-white rounded p-3 mt-2 border-t-4 border-gray-600 divide-y-2 divide-gray-300">
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Carrier Companies</div>
          <div class="text-3xl">{{ data.carrierCompanyCount | number }}</div>
        </div>
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Drivers Under Carriers</div>
          <div class="text-3xl">{{ data.driversWhoCouldDoTourCount | number }}</div>
        </div>
        <div class="flex w-full font-semibold justify-between items-center py-4">
          <div>Drivers Who Logged In</div>
          <div class="text-3xl">{{ data.driversWhoCouldDoTourHaveLoggedInCount | number }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
